/**
 * A `composer` reach frame is Bash speaking first (spec 2026-09-18 §5.4), and
 * the server files those words as a `composer_history` row too. This is that
 * row, built from the frame, so the words are in the composer's history the
 * moment they arrive instead of after a reload.
 *
 * IT MUST FOLD INTO THE SERVER'S ROW, never sit beside it: `mergeHistory`
 * matches on kind, question and time, so the question is cut exactly the way
 * the server cuts it (report-app.ts: the first line, trimmed, the first
 * HEAD_CHARS of it) and the time is the notice's own. The name is the notice's
 * id, so a redelivered frame (the rail is at-least-once) is the same row.
 */
import type { NamiNotifyPayload } from "@bash/shared";
import type { ComposerHistoryEntry } from "../composerHistoryStore";

/** The server's bound on a history row's question (apps/server sent-store.ts HEAD_CHARS). Keep the two equal. */
export const HISTORY_HEAD_CHARS = 120;

export function composerRowOf(
  frame: NamiNotifyPayload
): ComposerHistoryEntry | null {
  if (frame.kind !== "composer") return null;
  const ts = Date.parse(frame.createdAt);
  return {
    id: `reach:${frame.id}`,
    ts: Number.isFinite(ts) ? ts : Date.now(),
    question: frame.body.split("\n")[0]!.trim().slice(0, HISTORY_HEAD_CHARS),
    kind: "answered",
    text: frame.body,
    ...(frame.taskId ? { taskId: frame.taskId } : {}),
  };
}
